import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  n: '1',
  title: 'Sofort-Download',
  desc: 'Kaufen Sie und erhalten Sie sofortigen Zugriff auf alle 6 Bände und 5 Boni. Starten Sie jetzt – kein Warten auf Lieferung.'
}, {
  n: '2',
  title: 'Befolgen Sie das System',
  desc: 'Lernen Sie das Traffic Light System, das Load Master Protocol und das A.R.M.A. Schild in einer logischen Reihenfolge. Jeden Tag anwendbar.'
}, {
  n: '3',
  title: 'Verwalten Sie Ihre erste komplexe Verletzung',
  desc: 'Nach Band 3-4 werden Sie Ihr erstes Knie- oder Wirbelsäulen-Protokoll selbstbewusst bauen. Nach Band 6 sind Sie ein Rehab-Experte.'
}];
export function Steps() {
  return <section aria-label="So funktioniert es" className="bg-transparent" data-id="element-164" data-mp="fq795xo7tuxl">
      <div className="mx-auto max-w-4xl px-5 py-12" style={{
      paddingTop: "12px",
      paddingBottom: "17px"
    }} data-id="element-165" data-mp="261bx7e0gvq4a">
        <h2 className="text-center font-display text-2xl font-black text-grape sm:text-3xl" data-id="element-166" data-mp="2a3qfnx084nv1">
          Wie Sie ab heute fortschreiten
        </h2>
        <p className="mt-3 text-center text-sm text-plum/60" data-id="element-167" data-mp="1q998clhrvpqq">In nur 3 einfachen Schritten</p>

        <ol className="mt-10 space-y-4" data-id="element-168" data-mp="1lbzd2p7pcjuz">
          {steps.map((s, i) => <motion.li key={s.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: i * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex items-start gap-4 rounded-2xl border border-grape/15 bg-white p-5" data-id="element-169" data-mp="2003u7or3wnbn" data-mpi={i}>
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-grape font-display text-base font-black text-white" data-id="element-170" data-mp="1hae3pdudmnpj">
                {s.n}
              </span>
              <div data-id="element-171" data-mp="2spt0agiobdk4">
                <h3 className="text-base font-bold text-plum" data-id="element-172" data-mp="2sp1dnv720q5z">{s.title}</h3>
                <p className="mt-1 text-sm leading-relaxed text-plum/65" data-id="element-173" data-mp="2nqq0bahjvxj0">{s.desc}</p>
              </div>
            </motion.li>)}
        </ol>
      </div>
    </section>;
}